/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_Cut_DietInputs */

const en_portal_goal_cut_diet = /** @type {(inputs: Portal_Goal_Cut_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2100 kcal, high protein, counted by photo`)
};

const pl_portal_goal_cut_diet = /** @type {(inputs: Portal_Goal_Cut_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2100 kcal, dużo białka, liczone zdjęciem`)
};

/**
* | output |
* | --- |
* | "2100 kcal, high protein, counted by photo" |
*
* @param {Portal_Goal_Cut_DietInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_cut_diet = /** @type {((inputs?: Portal_Goal_Cut_DietInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_Cut_DietInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_cut_diet(inputs)
	return en_portal_goal_cut_diet(inputs)
});